module.exports = __webpack_public_path__ + "img/a2196d8a3fb65720447fc46151e8fe93.01468775.jpg";